module.exports = __webpack_public_path__ + "static/media/icon_account_info.99932da7.png";